export type SeasonSelectorType = 'main' | 'standings'
/**
 * Time indicator for TBA (To Be Announced) games
 * Used to indicate that the game is not yet scheduled
 * and the time is not yet known
 */
export const TBA_TIME_INDICATOR = ':23'
export const GAME_POLLING_INTERVAL_TIME = 20000 //20 secs
export const GAME_CHECK_INTERVAL_TIME = 10000 // 10 secs
export const STALE_SEASON_EVENTS_INTERVAL_TIME = 300000 //5 mins

export const SEASON_SELECTOR_TYPES: { [key: string]: SeasonSelectorType } = {
  MAIN: 'main',
  STANDINGS: 'standings',
}

export const SEASON_CONFERENCES: { [key: number]: string[] } = {
  2024: ['eastern', 'western'],
  2025: ['eastern', 'western'],
}

export const PLL_CONFERENCES = {
  EASTERN: 'eastern',
  WESTERN: 'western',
}
